import ListItem from './components/ListItem.vue';
import { checkWishlist } from '../project/favourites';
const axios = require('axios');

const wishlistApp = {
    components: { ListItem },
    data() {
        return {
            dataApi: '',
            dataLimit: 9999,
            dataSortKey: '',
            dataSortDirection: '',
            wishlist: [],
            loading: false,
            language: 'nl',
            data: null
        }
    },
    watch: {
        wishlist(newWishlist) {
            localStorage.wishlist = JSON.stringify(newWishlist);
            window.dispatchEvent(new CustomEvent('wishlist-localstorage-changed', {
                detail: {
                    storage: localStorage.getItem('wishlist')
                }
            }));
        }
    },
    computed: {
        itemsSet() {
            return this.data && this.data.items && this.data.items.length;
        },
        filterItems() {
            return [{
                Key: 'cmsId',
                Values: this.wishlistIds,
                Operator: 'In'
            }]
        },
        queryModel() {
            return {
                Limit: this.dataLimit,
                Offset: 0,
                OrderItems: this.orderItems,
                FilterItems: this.filterItems,
                Text: ''
            }
        },
        wishlistIds() {
            let result = this.wishlist.map(event => event.id);
            return result;
        }
    },
    methods: {
        async init() {
            this.loading = true;
            if (this.$el.parentNode.dataset.language) this.language = this.$el.parentNode.dataset.language;
            if (this.$el.parentNode.dataset.api) this.dataApi = this.$el.parentNode.dataset.api + '?lang=' + this.language;
            if (this.$el.parentNode.dataset.limit) this.dataLimit = parseInt(this.$el.parentNode.dataset.limit);
            if (this.$el.parentNode.dataset.sortkey) this.dataSortKey = this.$el.parentNode.dataset.sortkey;
            if (this.$el.parentNode.dataset.sortdirection) this.dataSortDirection = this.$el.parentNode.dataset.sortdirection;

            if (this.wishlistIds.length) {
                const overruleResponse = await this.fetchData();
                this.setData(overruleResponse);
            }
            this.loading = false;
        },
        async fetchData() {
            try {
                const response = await axios.post(this.dataApi, this.queryModel);
                return response;
            } catch (error) {
                console.log(error);
            }
        },
        setData(response) {
            if (!response || response.status != 200) return;
            this.data = response.data;
            this.data.items = this.data.items.map(item => {
                return {
                    ...item,
                    favorite: this.wishlistIds.some(wishlistId => wishlistId === item.id),
                }
            });
        },
        async handleRemoveFavorite(id) {
            if (this.wishlistIds.some(wlid => wlid === id)) {
                let newWishlistIds = this.wishlistIds.filter((wlid) => {
                    return wlid != id;
                });
                let newWishlist = this.wishlist.filter((wlItem) => {
                    return newWishlistIds.find((nwlId) => {
                        return wlItem.id === nwlId
                    })
                });
                this.wishlist = newWishlist;
                if (this.wishlist.length) {
                    const overruleResponse = await this.fetchData();
                    this.setData(overruleResponse);
                } else {
                    this.data.items = [];
                    localStorage.removeItem('wishlist');
                }
                checkWishlist(true);
            }
        }
    },
    mounted() {
        if (localStorage.wishlist) {
            this.wishlist = JSON.parse(localStorage.wishlist);
        }
        this.init();
    }
}

export default wishlistApp;